<style lang="scss">
    .wx-toast {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 990;
        background-color: rgba(0, 0, 0, 0);

        .wx-toast-inner {
            text-align: center;
            background-color: rgba(0, 0, 0, 0.5);
            color: #ffffff;
            position: fixed;
            top: 50%;
            left: 50%;
            margin-left: -75px;
            margin-top: -48px;
            width: 150px;
            border-radius: 6px;
            font-size: 14px;
            padding: 15px 10px;
            font-family: PingFangSC-Regular, sans-serif;
        }
    }

    .hidden {
        transform: scale(0);
        transition: 0.01s;
    }

</style>

<template>
    <div class="wx-toast" :class="{'hidden': !show}">
        <div class="wx-toast-inner">
            {{ message }}
        </div>
    </div>
</template>

<script>
export default {
  name: 'ToastDialog',
  replace: true,
  data () {
    return {
      message: '',
      show: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ToastDialog.vue